// Components
export { CheckoutButton } from './components/CheckoutButton';
export { PricingTable } from './components/PricingTable';
export { PaymentForm, type PaymentFormProps } from './components/PaymentForm';
export { BillingPortal } from './components/BillingPortal';
export { SubscriptionPlans } from './components/SubscriptionPlans';
export { SubscriptionManager } from './components/SubscriptionManager';
export {
  SubscriptionCard,
  type SubscriptionCardProps,
} from './components/SubscriptionCard';
export { BillingHistory } from './components/BillingHistory';
export { PaymentMethods } from './components/PaymentMethods';

// Stripe-specific exports for backward compatibility
export {
  StripePaymentForm,
  StripePaymentFormDefault,
  type StripePaymentFormProps,
} from './components/StripePaymentForm';
export { SubscriptionManager as StripeSubscriptionManager } from './components/SubscriptionManager';
export { PricingTable as StripePricingTable } from './components/PricingTable';

// Provider-specific components (temporarily commented out due to build issues)
// export { PayPalButton, PayPalSubscriptionButton } from '../components/web/PayPalButton';
// export { ApplePayButton, ApplePaySubscriptionButton } from '../components/web/ApplePayButton';
// export { MultiProviderPayment } from '../components/web/MultiProviderPayment';

// Export types for the new components
export type {
  PricingPlan,
  SubscriptionPlansProps,
} from './components/SubscriptionPlans';
export type {
  Subscription,
  SubscriptionAction,
  SubscriptionManagerProps,
} from './components/SubscriptionManager';
export type { Invoice, BillingHistoryProps } from './components/BillingHistory';
export type {
  PaymentMethod,
  PaymentMethodsProps,
} from './components/PaymentMethods';

// Provider-specific component types (temporarily commented out due to build issues)
// export type {
//   PayPalButtonProps,
//   PayPalSubscriptionButtonProps,
// } from '../components/web/PayPalButton';
// export type {
//   ApplePayButtonProps,
//   ApplePaySubscriptionButtonProps,
// } from '../components/web/ApplePayButton';
// export type {
//   MultiProviderPaymentProps,
// } from '../components/web/MultiProviderPayment';

// Providers
export { StripeProvider } from './providers/StripeProvider';

// React Providers and Hooks (client-side only)
export {
  PaymentsProvider,
  usePaymentsContext,
} from '../shared/providers/PaymentsProvider';
export { usePayments } from '../shared/hooks/usePayments';

// Web-specific hooks
export { useSubscription } from './hooks/useSubscription';
export { useCheckout } from './hooks/useCheckout';
export { useCustomer } from './hooks/useCustomer';

// Analytics hooks (when available)
// export { useSubscriptionAnalytics } from '../shared/hooks/useSubscriptionAnalytics';
// export { useRevenueAnalytics } from '../shared/hooks/useRevenueAnalytics';

// Utils
export * from './utils/stripe-web';
